import type { LoanAccount } from '@coreledger/shared-types';
import { api } from './client';
import type { PaginationMeta } from './invoices';

export interface Paginated<T> { data: T[]; meta: PaginationMeta }

export const loanAccountsApi = {
  list: (page = 1, limit = 50) => api.get<Paginated<LoanAccount>>(`/loan-accounts?page=${page}&limit=${limit}`),
  get: (id: string) => api.get<LoanAccount>(`/loan-accounts/${id}`),
  create: (data: Partial<LoanAccount>) => api.post<LoanAccount>('/loan-accounts', data),
  update: (id: string, data: Partial<LoanAccount>) => api.patch<LoanAccount>(`/loan-accounts/${id}`, data),
  delete: (id: string) => api.delete<void>(`/loan-accounts/${id}`),
};
